var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_31065)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.9727,
    cy: 18.2632,
    r: 10.0547,
    fill: "url(#paint0_linear_1433_31065)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.843 1.3335C20.493 1.3335 22.143 2.06683 23.1513 3.44183L27.643 9.0335C28.3763 10.0418 28.8346 11.2335 28.8346 12.4252V25.1668C28.8346 28.1918 26.3596 30.6668 23.3346 30.6668H8.66797C5.64297 30.6668 3.16797 28.1918 3.16797 25.1668V6.8335C3.16797 3.8085 5.64297 1.3335 8.66797 1.3335H18.843ZM21.6846 11.6918C20.0346 10.0418 17.468 9.8585 15.6346 11.3252C15.268 11.6002 15.1763 12.2418 15.4513 12.6085C15.7263 12.9752 16.368 13.0668 16.7346 12.7918C17.8346 11.9668 19.393 12.0585 20.3096 13.0668C21.4096 14.1668 21.4096 15.9085 20.3096 16.9168L17.1013 20.1252L15.543 21.6835L15.4513 21.7752C14.3513 22.7835 12.7013 22.6918 11.693 21.6835C10.6846 20.6752 10.593 19.0252 11.6013 17.9252L11.693 17.8335L13.8013 15.7252L13.893 15.6335C14.2596 15.3585 14.8096 15.3585 15.0846 15.7252C15.4513 16.0918 15.4513 16.6418 15.0846 17.0085L12.9763 19.1168L12.8846 19.2085C12.6096 19.5752 12.6096 20.1252 12.9763 20.4002C13.343 20.7668 13.893 20.7668 14.2596 20.4002L16.368 18.2918L16.4596 18.2002C17.3763 17.1002 17.3763 15.4502 16.368 14.4418C15.268 13.3418 13.5263 13.3418 12.518 14.4418L11.693 15.2668L11.6013 15.3585L11.0513 15.9085L10.4096 16.5502C8.5763 18.3835 8.5763 21.2252 10.4096 23.0585C12.243 24.8918 15.0846 24.8918 16.918 23.0585L19.0263 20.9502L19.118 20.8585L21.7763 18.2002L21.9596 18.0168C23.4263 16.2752 23.4263 13.4335 21.6846 11.6918Z",
    fill: "url(#paint1_linear_1433_31065)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_31065",
    x1: 15.9727,
    y1: 8.2085,
    x2: 16.668,
    y2: 26.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1433_31065",
    x1: 16.0013,
    y1: 1.3335,
    x2: 16.0013,
    y2: 30.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFABA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF766A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_31065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.3333,
    height: 29.3333,
    fill: "white",
    transform: "translate(1.33398 1.3335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon1);
export default __webpack_public_path__ + "static/media/mail_card_icon1.b76365407afc519435d4b5f3b2c62d53.svg";
export { ForwardRef as ReactComponent };